<!-- Chat Toggle Button -->
<div class="chat-toggle" 
     [class.active]="isOpen" 
     (click)="toggleChat()"
     title="Asistente inmobiliario">
  <svg *ngIf="!isOpen" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16Z" fill="currentColor"/>
  </svg>
  <svg *ngIf="isOpen" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="currentColor"/>
  </svg>
</div>

<!-- Chat Window -->
<div class="chat-window" [class.open]="isOpen">
  <div class="chat-header">
    <div class="chat-title">
      <div class="avatar-container">
        <div class="avatar">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM12 14.2C10.5 14.2 9.3 13.5 9.3 12.6V11.8C9.3 10.9 10.5 10.2 12 10.2S14.7 10.9 14.7 11.8V12.6C14.7 13.5 13.5 14.2 12 14.2ZM12 8C13.5 8 14.7 8.7 14.7 9.6V10.4C14.7 11.3 13.5 12 12 12S9.3 11.3 9.3 10.4V9.6C9.3 8.7 10.5 8 12 8Z" fill="currentColor"/>
          </svg>
        </div>
        <div class="status-indicator"></div>
      </div>
      <div class="title-text">
        <h4>Asistente Inmobiliario</h4>
        <span class="status-text">En línea</span>
      </div>
    </div>
    <button class="close-btn" (click)="toggleChat()">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="currentColor"/>
      </svg>
    </button>
  </div>

  <div class="chat-messages">
    <div *ngFor="let message of messages" 
         class="message" 
         [class.user-message]="message.isUser"
         [class.bot-message]="!message.isUser">
      <div class="message-content">
        <div class="message-text">{{ message.text }}</div>
        <div class="message-time">
          {{ message.timestamp | date:'HH:mm' }}
        </div>
      </div>
    </div>
    
    <div *ngIf="isLoading" class="message bot-message">
      <div class="message-content">
        <div class="typing-indicator">
          <div class="typing-dot"></div>
          <div class="typing-dot"></div>
          <div class="typing-dot"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="chat-input">
    <div class="input-container">
      <textarea 
        [(ngModel)]="currentMessage"
        (keypress)="onKeyPress($event)"
        placeholder="Escribe tu mensaje..."
        rows="1"
        class="message-input"></textarea>
      <button 
        class="send-btn" 
        (click)="sendMessage()"
        [disabled]="!currentMessage.trim() || isLoading">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2.01 21L23 12L2.01 3L2 10L17 12L2 14L2.01 21Z" fill="currentColor"/>
        </svg>
      </button>
    </div>
  </div>
</div>